import React,{useState} from "react"
import { CheckImg } from "../CheckImg";
import {BASE_URL, FILE_URL} from "../../../config";

export default function SpaceInText({data, changeHandler, isPassed}) {
  const [answer, setAnswer] = useState(null);
  const ChangeHandler = event => {
    setAnswer({...answer, [event.target.name]: [event.target.value]});
    changeHandler(event);
  };

  let info = [];
  let validAnswer = data.filter((item, k) => {
    if (k % 2 !== 0)
      return item
  });

  const styles = {
    right: {
      border: '3px solid rgba(128, 253, 195, 0.76)',
    },
    wrongUser: {
      border: '3px solid rgba(253, 128, 128, 0.76)',
    },
  }

  function CheckAnswer(validAnswer, answer) {
    for (let i = 0; i < validAnswer.length; i++) {
      if (answer !== null && answer[i] !== undefined) {
        info[i] = validAnswer[i].replace(/ /g, '').toUpperCase() === answer[i].toString().replace(/ /g, '').toUpperCase();
      } else {
        info[i] = false;

      }
    }
  }

  if (isPassed) {
    CheckAnswer(validAnswer, answer);
  }

  return (// убрать стайл
      <div style={{display: 'flex'}}>
        <pre className="test-space-in-text-str">
          {
            data.map((item, k) => (
                k % 2 === 0 ?
                    CheckImg(item).length !== 0 ?
                        CheckImg(item).map(element => (
                            element.includes('{!') ?
                                <img src={BASE_URL + FILE_URL + '/' + element.replace("{!img", '').replace('!}', '')}
                                     alt="media" key={item}/> :
                                element
                        )) :
                        item :
                    <input type={'text'} onChange={e => ChangeHandler(e)} defaultValue=''
                           style={isPassed ? info[Math.trunc((k - 1) / 2)] ? styles.right : styles.wrongUser : null}
                           name={((k - 1) / 2)} key={"answer" + (k)} disabled={isPassed}/>
            ))}
        </pre>
      </div>
  )
}